
/*
 * Общие функции для Организаций
 *
 * */

; window.OK = (() => {
	"use strict";

	if (!window.PARAMS) {
		console.error('[OK] PARAMS.js не загружен до OrganizationKit.js');
	}
	if (!window.FFK) {
		console.error('[OK] FormFieldKit.js не загружен до OrganizationKit.js');
	}
	if (!window.jQuery) {
		console.error('[OK] jQuery не загружен до OrganizationKit.js');
	}
	if (!window.aAlert) {
		console.error('[OK] aAlert не загружен до OrganizationKit.js');
	}
	if (!window.aConfirm) {
		console.error('[OK] aConfirm не загружен до OrganizationKit.js');
	}

	//dictionary
	const dic = {
		ORGANIZATION_FORMS: [{
			code: "fiz",
			value: "100731702",
			name: "Физическое лицо"
		},
		{
			code: "ip",
			value: "100679729",
			name: "Индивидуальный предприниматель"
		},
		{
			code: "ur",
			value: "100731703",
			name: "Юридическое лицо"
		}],
	}

	const api = {
		/**
		 * Получить данные по ИНН
		 * @param {type} payload
		 * @returns {HK=>#7.innUtils.getDataByInn.data}
		 */
		async getDataByInn(payload) {
			const { inn, sid } = { ...payload };

			if (!inn) {
				return { success: false, error: "Не указан инн!" };
			}
			if (!sid) {
				return { success: false, error: "Ошибка передачи данных!" };
			}

			try {
				const response = await fetch("/ajax/getPartyData", {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'X-Requested-With': 'XMLHttpRequest',
					},
					body: new URLSearchParams({
						inn: inn,
						sid: sid
					})
				});

				// Проверка статуса ответа
				if (!response.ok) {
					throw new Error(`HTTP ${response.status}: ${response.statusText}`);
				}

				const data = await response.json();

				PARAMS.isStage && console.info('[innUtils] Данные получены', data)

				// Если сервер вернул ошибку — выбрасываем исключение
				if (data?.error) {
					return { success: false, error: data.error };
				}

				// Флаг перезагрузки страницы
				if (data?.reload) {
					data._needsReload = true;
				}

				return { success: true, data: data };
			} catch (e) {
				const err = e.message || 'Ошибка получения данных по ИНН';
				await aAlert(err);
				return { success: false, error: err };
			}
		},

		/*
		 * Проверка ИНН в реквизитах получателя ИНН
		 * /ajax/checkRecipientInn
		 * {"success":true,"isBank":false,"message":"Некорректный ИНН"}
		 *
		 */
		async checkRecipientInn(payload) {
			const { inn, sid } = { ...payload };
			if (!inn) {
				return { success: false, error: "Не указан инн!" };
			}
			if (!sid) {
				return { success: false, error: "Ошибка передачи данных!" };
			}

			try {

				const response = await fetch("/ajax/checkRecipientInn", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(payload)
				});

				if (!response.ok) {
					throw new Error(`HTTP ${response.status}`);
				}

				const result = await response.json();

				if (!result.success || !result.data?.length) {
					return { success: false, error: "Нет данных" };
				}

				return result;
			} catch (e) {
				return { success: false, error: e };
			}
		},
	};


	// ═══════════════════════════════════════════════════════════════
	// СПИСОК ПОЛЕЙ ОРГАНИЗАЦИИ (Маппинг: Поле в сторе -> Ключ с бэкенда)
	// ═══════════════════════════════════════════════════════════════
	const ORGANIZATION_FIELDS_MAP = {
		ogrn: "ogrn",
		kpp: "kpp",
		legal_name: "full_name",
		title: "title",
		legal_address: "adres",
		famil: "famil",
		imya: "imya",
		otch: "otch",
	};


	// Функции обновления данных в объекте/хранилище
	const storeManipulations = {

		// чистим чистим чистим
		clearOrganizationData(params = {}) {
			const {
				store,
				fieldsPrefix = "",
				clearWithInn = false,
				clearWithSnils = false,
			} = params;

			if (!store) {
				return;
			}
			const F = (name) => fieldsPrefix + name; // Хелпер для формирования имен полей

			Object.keys(ORGANIZATION_FIELDS_MAP).forEach(field => {
				store[F(field)] = '';
			});
			if (clearWithInn && store[F("inn")]) {
				store[F("inn")] = '';
			}
			if (clearWithSnils && store[F("snils")]) {
				store[F("snils")] = '';
			}
		},

		// проверяем поля на существование в объекте
		isExistFields(params = {}) {
			const { store, fieldsPrefix = "" } = params;
			if (!store) {
				return false;
			}


			const F = (name) => fieldsPrefix + name;

			// Проверяем поля данных (с префиксом)
			for (const field of Object.keys(ORGANIZATION_FIELDS_MAP)) {
				if (typeof store[F(field)] === 'undefined') {
					console.error(`Поля ${F(field)} нет в хранилище`, store);
					return false;
				}
			}

			// Проверяем флаг автозаполнения (с префиксом)
			if (typeof store[F("is_party_data_autofilled")] === 'undefined') {
				console.error(`Поля ${F("is_party_data_autofilled")} нет в хранилище`, store);
				return false;
			}

			if (typeof store.partyDataLoading === 'undefined') {
				console.error(`Поля partyDataLoading нет в хранилище`, store);
				return false;
			}

			// Проверяем флаги типа организации (БЕЗ ПРЕФИКСА!)
			const flags = ["isFiz", "isUr", "isIp"];
			for (const flag of flags) {
				if (typeof store[flag] === 'undefined') {
					console.error(`Флага ${flag} нет в хранилище`, store);
					return false;
				}
			}
			return true;
		},

		/**
		 * Автозаполнение полей по ИНН
		 * Данные меняются по ссылке на объект (особенно эффективно с alpine хранилищем)
		 *
		 * @param {boolean} silent - не показывать уведомления
		 */
		async setDataByInn(params = {}) {
			const {
				silent = false,
				store,
				fieldsPrefix = "",
				sid = PARAMS?.SID ?? null,
				localCheckFunc = store?.validateField?.bind(store) ?? (async () => ({ isValid: true })),
			} = params;
			if (!store) {
				return false;
			}
			if (!sid) {
				console.error("[OK.getInnAutoData] Не указан sid!");
				return false;
			}
			if (!this.isExistFields(params)) {
				return false;
			}


			const F = (name) => fieldsPrefix + name;

			// Если в тихом режиме вызываем функцию, то будет работать когда режим автозаполнения (onchange)
			if (silent && !store[F("is_party_data_autofilled")]) {
				return false;
			}

			// Физ. лицо - выходим
			if (store.isFiz) {
				store[F("is_party_data_autofilled")] = false;
				return false;
			}

			// Валидация ИНН
			const localCheck = await localCheckFunc(F("inn"));
			if (localCheck.isValid === false) {
				if (!silent) {
					aAlert(localCheck?.error?.message ?? "Некорректный ИНН!");
					return false;
				} else if (!store[F("is_party_data_autofilled")]) {
					this.clearOrganizationData(params);
				}
				return false;
			}

			const innVal = store[F("inn")];
			const innStr = String(innVal || "");

			// Проверка длины ИНН для ЮР лица
			if (store.isUr && innStr.length === 12) {
				if (!silent) {
					aAlert("Укажите ИНН юридического лица!");
				}

				return false;
			}


			// Проверка длины ИНН для ИП
			if (store.isIp && innStr.length === 10) {
				if (!silent) {
					aAlert("Укажите ИНН индивидуального предпринимателя!");
				}

				return false;
			}


			const payload = { inn: innVal, sid: sid };

			const handleError = (e) => {
				const attention = ` Проверьте тип ${CTX()?.comp?.dolz_a || 'организации'} и правильность ввода ИНН.`;
				const msg = (e?.message || e || "Неизвестная ошибка") + attention;

				if (store[F("is_party_data_autofilled")]) {
					this.setManualInnDataRegime({
						store,
						fieldsPrefix,
						silent: false,
						confirmText: msg + "<br>Ввести реквизиты вручную?"
					});
				} else {
					if (!silent) {
						aAlert(msg);
					}
				}
			};


			try {
				store.partyDataLoading = true;
				const result = await api.getDataByInn(payload);

				if (result.success) {
					const data = result.data || {};

					// Заполняем поля из единого списка
					Object.entries(ORGANIZATION_FIELDS_MAP).forEach(([storeField, backendKey]) => {
						store[F(storeField)] = data[backendKey] || "";
					});

					store[F("is_party_data_autofilled")] = true; // ставим то что заполнили автоматически
				} else {
					handleError(result.error);
				}

				if (result?.data?._needsReload) {
					window.location.reload();
					return true;
				}

				return !!result.success;
			} catch (e) {
				console.error(e);
				handleError(e);
				return false;
			} finally {
				store.partyDataLoading = false;
			}
		},
		/**
		 * Переключение в режим ручного ввода реквизитов
		 * Нажатие на кнопку ввести все данные вручную
		 */
		setManualInnDataRegime(params = {}) {
			const {
				store,
				fieldsPrefix = "",
				silent = false,
				confirmText = "Вы действительно хотите ввести реквизиты вручную?"
			} = params;

			if (!store) {
				return false;
			}


			const F = (name) => fieldsPrefix + name;
			const autoFilledField = F("is_party_data_autofilled");

			if (!silent) {
				aConfirm(confirmText).then((response) => {
					if (response) {
						store[autoFilledField] = false; // ставим маркер, что вручную вводим
					}
				});
				return false;
			}
			store[autoFilledField] = false;
			return false;
		},
	};

	//
	//  ============ ТРЕБУЕТ РЕФАКТОРИНГА ============
	//

	function syncDkpIpCheckbox(formSel, rs) {
		var $cb = $("[name=dkp_is_ip]", formSel);
		if (!$cb.length) {
			return;
		}
		var d = FFK.format("digitsOnly", rs);
		if (d.length < 5) {
			return;
		}
		if (d.substr(0, 5) === "40802") {
			$cb.prop("checked", true);
		} else if (d.substr(0, 5) !== "40817") {
			$cb.prop("checked", false);
		}
	}

	function applyIpPrefixByRs(rs, name) {
		var d = FFK.format("digitsOnly", rs);
		if (d.length < 5) {
			return name;
		}
		if (d.substr(0, 5) === "40802") {
			if (hasIpNamePrefix(name)) {
				return name;
			}
			var n = (name || "").replace(/^\s+|\s+$/g, "");
			return "ИП " + n;
		}
		if (d.substr(0, 5) === "40817") {
			return name;
		}
		return stripIpPrefix(name);
	}


	function stripIpPrefix(name) {
		if (typeof name !== "string") {
			return name;
		}
		var trimmed = name.replace(/^\s+/, "");
		if (trimmed.toLowerCase().indexOf("ип ") === 0) {
			return trimmed.substring(3).replace(/^\s+/, "");
		}
		return name;
	}


	const legacy = {
		/**
		 * Получение реквизитов банка при вводе наименования или БИК через библиотеку suggestions
		 * @param {type} selector - селектор
		 * @param {type} bank
		 * @param {type} bik
		 * @param {type} ks
		 * @param {type} rs
		 * @returns {undefined}
		 */
		bankDetails(selector, bank, bik, ks, rs) {
			var plugin_bank = $("[name=" + bank + "]", selector).suggestions({
				//token: Conf.get("dadata_token"),
				type: "BANK",
				onSelectNothing: function () {
					$("[name=" + rs + "]").val("");
					$("[name=" + bik + "]").val("");
					$("[name=" + ks + "]").val("");
					if ($(this).val().length === 0) {
						$(this).removeClass('invalid').removeClass('valid');
					} else {
						$(this).removeClass('valid').addClass('invalid');
					}
				},
				/* Вызывается, когда пользователь выбирает одну из подсказок */
				onSelect: function (suggestion) {
					if (suggestion) {
						$(this).removeClass('invalid').addClass('valid');
						$("[name=" + bik + "]").val(suggestion.data.bic);
						var ksch = suggestion.data.correspondent_account;
						if (!ksch && suggestion.data.treasury_accounts) {
							ksch = suggestion.data.treasury_accounts[0];
						}
						$("[name=" + ks + "]").val(ksch);
					} else {
						$(this).removeClass('valid').addClass('invalid');
						$("[name=" + bank + "]").val("");
					}
				},
				onSearchError: function () {
					$("[name=" + bik + "]").removeAttr("readonly");
					$("[name=" + ks + "]").removeAttr("readonly");
					plugin_bank.hide();
				},

				onSuggestionsFetch: function (suggestionsArray) {
					//console.log(suggestionsArray, 'suggestionsArray')

					// Преобразуем в формат DaData
					return suggestionsArray.map(function (item) {
						var ksch = item.correspondent_account;
						if (!ksch && item.treasury_accounts?.[0]) {
							ksch = item.treasury_accounts[0];
						}

						return {
							value: item.name_p || item.name,
							unrestricted_value: item.name_p || item.name,
							data: {
								bic: item.bik,
								inn: item.inn || "",
								kpp: item.kpp || "",
								correspondent_account: ksch,
								treasury_accounts: item.treasury_accounts,
								name: { payment: item.name_p || item.name },
								address: {
									value: item.adr || item.address || "",
									unrestricted_value: item.adr || item.address || ""
								},
								opf: { type: "BANK" },
								state: { status: "ACTIVE" }
							}
						};
					});
				},

				geoLocation: false, // отключаем возврат списка по геолокации (у нас на бэке это даже не реализовано, если что)
				notSuggestionResponseFormat: true, // получаем не suggestion, а data объект
				serviceUrl: "/ajax/api/banks_data",
			}).suggestions();
		},

		/**
		 * Проверяет адрес на корректность по dadata
		 * Проверка по уровню детализации адреса (fias_level)
		 *
		 * https://dadata.ru/api/suggest/address/
		 * 0 - страна,
		 * 1 - регион,
		 * 3 - район,
		 * 4 - город,
		 * 5 - район города,
		 * 6 - населенный пункт,
		 * 7 - улица,
		 * 8 - дом,
		 * 9 - квартира или комната,
		 * 65 - планировочная структура,
		 * 75 - земельный участок,
		 * -1 - иностранный или пустой
		 *
		 * @param suggestion - ответ по api dadata
		 * @param minRequiredLevel - минимальный требуемый уровень детализации адреса
		 */
		checkAddressCompleteness(suggestion, minRequiredLevel = 7) {
			const data = suggestion.data;
			const fiasLevel = Number(data.fias_level); // уровень адреса

			if (fiasLevel < minRequiredLevel) { // если меньше минимального уровня
				return {
					isComplete: false,
					message: "Введите адрес полностью!",
					fiasLevel: fiasLevel,
				};
			} else {
				return {
					isComplete: true,
					message: "Адрес полный",
					fiasLevel: fiasLevel,
				};
			}
		},

		residentialComplexDetails(selector, fieldName) {
			var serviceUrl = '/ajax/api/residential_complexes_data';

			function getItemTitle(item) {
				return item.name || ('ЖК #' + item.cian_id);
			}

			function getItemAddress(item) {
				return item.matching_house_address || item.address || '';
			}

			function getSuggestionLabel(item) {
				var displayId = item.matching_house_id || item.cian_id;
				var complexHint = item.matching_house_id ? (' | ЖК ' + item.cian_id) : '';
				var address = getItemAddress(item);
				return displayId + complexHint + ' | ' + getItemTitle(item)
					+ (address ? ' | ' + address : '')
					+ (item.region ? ' | ' + item.region : '');
			}

			function setInputState($input, state) {
				if (state === 'valid') {
					$input.removeClass('invalid').addClass('valid');
					return;
				}
				if (state === 'typing') {
					$input.removeClass('valid');
					return;
				}
				if (state === 'empty') {
					$input.removeClass('invalid').removeClass('valid');
					return;
				}
				$input.removeClass('valid').addClass('invalid');
			}

			function clearSelection($input, $hidden) {
				$hidden.val('');
				setInputState($input, $input.val().length === 0 ? 'empty' : 'invalid');
			}

			function applySuggestion($input, $hidden, suggestion) {
				if (suggestion && suggestion.data && suggestion.data.cian_id) {
					$hidden.val(String(suggestion.data.cian_id));
					$input.val(suggestion.value || '');
					setInputState($input, 'valid');
					return;
				}
				clearSelection($input, $hidden);
			}

			function preloadSelectedValue($input, $hidden) {
				if (!$hidden.val()) {
					return;
				}

				jQuery.ajax({
					url: serviceUrl,
					method: 'get',
					dataType: 'json',
					data: { query: $hidden.val(), count: 1 },
					success: function (response) {
						var item = response && response.data && response.data.length ? response.data[0] : null;
						if (item) {
							$input.val(getSuggestionLabel(item));
							setInputState($input, 'valid');
						}
					}
				});
			}

			function mapSuggestion(item) {
				var title = getItemTitle(item);
				var address = getItemAddress(item);
				var label = getSuggestionLabel(item);
				return {
					value: String(label || ''),
					unrestricted_value: String(label || ''),
					data: {
						cian_id: String(item.cian_id || ''),
						matching_house_id: String(item.matching_house_id || ''),
						name: { payment: String(title || '') },
						address: {
							value: String(address || ''),
							unrestricted_value: String(address || '')
						},
						region: String(item.region || ''),
						matching_house_address: String(item.matching_house_address || ''),
					}
				};
			}

			$('[name="' + fieldName + '"]', selector).each(function () {
				var $hidden = $(this);
				var $input = $hidden.siblings('[name="cian_jkschema_title[]"]').first();
				var plugin_residential;

				if (!$input.length || $input.data('residential-complex-init')) {
					return;
				}

				$input.data('residential-complex-init', true);

				$input.on('input', function () {
					$hidden.val('');
					setInputState($(this), $(this).val().length === 0 ? 'empty' : 'typing');
				});

				preloadSelectedValue($input, $hidden);

				plugin_residential = $input.suggestions({
					type: "ADDRESS",
					showUnrestricted: false,
					noSuggestionsHint: "Неизвестный ЖК",
					onSelectNothing: function () {
						clearSelection($(this), $hidden);
					},
					onSelect: function (suggestion) {
						applySuggestion($(this), $hidden, suggestion);
					},
					onSearchError: function () {
						plugin_residential.hide();
					},
					formatResult: function (value, currentValue, suggestion) {
						var address = (suggestion.data.address && suggestion.data.address.value)
							|| suggestion.data.matching_house_address
							|| '';
						var meta = [suggestion.data.region || '', address].filter(Boolean).join(' | ');
						return suggestion.value + (meta ? '<br><small>' + meta + '</small>' : '');
					},
					formatSelected: function (suggestion) {
						return suggestion && suggestion.value ? String(suggestion.value) : '';
					},
					onSuggestionsFetch: function (suggestionsArray) {
						return suggestionsArray.map(mapSuggestion);
					},
					geoLocation: false,
					notSuggestionResponseFormat: true,
					serviceUrl: serviceUrl
				}).suggestions();
			});
		},

		bindIpPrefixAutoFill(formSel, rsName, titleName) {
			var $rs = $("[name=" + rsName + "]", formSel);
			var $title = $("[name=" + titleName + "]", formSel);
			if (!$rs.length || !$title.length) {
				return;
			}
			$rs.on("input change", function () {
				if ($title.prop("disabled")) {
					return;
				}
				var next = applyIpPrefixByRs($rs.val(), $title.val());
				if (next !== $title.val()) {
					$title.val(next);
				}
				if (titleName === "dkp_recipient_name") {
					syncDkpIpCheckbox(formSel, $rs.val());
				}
			});
		}
	}

	// тоже нуждается в рефакторинге
	const Forms_Layer = {
		onDkpIpCheckboxChange() {
			if (typeof updateRecipientFromOwner === "function") {
				updateRecipientFromOwner();
			}
			var $title = $("[name=dkp_recipient_name]");
			var $cb = $("[name=dkp_is_ip]");
			if (!$title.length || !$cb.length) {
				return;
			}
			if ($cb.prop("checked")) {
				if (!hasIpNamePrefix($title.val())) {
					var n = ($title.val() || "").replace(/^\s+|\s+$/g, "");
					$title.val("ИП " + n);
				}
			} else {
				$title.val(stripIpPrefix($title.val()));
			}
		}
	}


	// то, что будет доступно снаружи
	const publicAPI = {
		...api,
		...storeManipulations,
		...dic,
		...legacy,
		forms: Forms_Layer
	};

	return publicAPI;
})();
